import moment from "moment-timezone";
import React, {Component} from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Col from 'react-bootstrap/Col';
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import FormGroup from "react-bootstrap/FormGroup";
import Row from 'react-bootstrap/Row';
import {Link} from "react-router-dom";
import { LOGO_URL } from '../../Settings';

export default class NewUserRegistration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            submitted: false,
            submittedEmail: '',
            isSaved: true,
            isValid: false,
            eventType: null,
            eventTypeFrequency: {},

            username: '',
            usernameIsValid: false,
            usernameValidationmessage: '',
            apassword: '',
            apasswordIsValid: false,
            apasswordValidationmessage: '',
            apassword2: '',
            apassword2IsValid: false,
            apassword2Validationmessage: '',
            firstname: '',
            firstnameIsValid: false,
            firstnameValidationmessage: '',
            lastname: '',
            lastnameIsValid: false,
            lastnameValidationmessage: '',
            email: '',
            emailIsValid: false,
            emailValidationmessage: '',
            timezone: '',
            timezoneIsValid: false,
            timezoneValidationmessage: ''
        };

        this.onFieldChange = this.onFieldChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitErrorCallback = this.onSubmitErrorCallback.bind(this);
        this.onSubmitCallback = this.onSubmitCallback.bind(this);
        this.passwordCheck = this.passwordCheck.bind(this);
    }

    componentDidMount() {
        this.setState({timezone: this.props.authenticator.timeZone.name})
    }


    onFieldChange(event) {
        const isValid = event.target.validity.valid;
        const validationMessage = event.target.validationMessage;
        const fieldName = event.target.name;
        let newStates = {isSaved: false};
        newStates.isValid = !validationMessage;
        newStates[fieldName] = event.target.value;
        const isValidName = fieldName + 'IsValid';
        newStates[isValidName] = isValid;
        const validationMessageName = fieldName + 'ValidationMessage';
        newStates[validationMessageName] = validationMessage;
        this.setState(newStates, () => this.passwordCheck());
    }

    onSubmitErrorCallback(data, status) {
        this.setState({isSaved: false, submitted: false, errors: data});
    }

    onSubmitCallback(data) {
        if (!!!data) {
            return;
        }
        // 2026-05-26: registration now sends a verification email; no
        // auto-login. The backend returns
        // {detail: 'Verification email sent.', email, username,
        //  is_active: false} on success. The player follows the link
        // in the email; /register/:token then mounts
        // RegistrationResponse which confirms the token and logs in.
        this.setState({
            submitted: true,
            submittedEmail: data.email || this.state.email
        });
    }


    onSubmit(event) {
        event.preventDefault();
        this.setState({isSaved: true});

        const searchDict = this.props.location &&
            queryString.parse(this.props.location.search);
        let ref = null;
        if (searchDict) {
            if (searchDict.ref) {
                ref = searchDict.ref
            }
        }

        const data = {
            username: this.state.username,
            email: this.state.email,
            password: this.state.apassword,
            first_name: this.state.firstname,
            last_name: this.state.lastname,
            timezone: this.state.timezone,
            ref: ref
        };

        this.props.authenticator.queuedPost(
            'user_registration',
            data,
            this.onSubmitCallback,
            this.onSubmitErrorCallback
        )


    }

    passwordCheck() {
        if (this.state.apassword !== this.state.apassword2) {
            this.setState({
                passwordInvalid: true,
                errors: {apassword2: 'Does not match.'}
            })
        } else {
            let newErrors = {...this.state.errors}
            newErrors.apassword2 = null
            this.setState({
                passwordInvalid: false,
                errors: newErrors
            })
        }
    }

    timezoneList() {
        let timeZones;
        timeZones = moment.tz.names().map((tz) => {
            return tz
        });
        return timeZones
    }

    timezoneOptionList() {
        const timezones = this.timezoneList();
        let optionList = [];
        optionList.push(
            <option key={'-null'}
                    value=''
            >None Selected</option>
        );
        // eslint-disable-next-line no-unused-vars
        timezones.map((value, index) => {
            optionList.push(
                <option key={index}
                        value={value}
                >{value}</option>
            );
            return ''
        });
        return optionList;
    }

    render() {
        if (this.state.submitted) {
            return <Container style={{color: 'white'}}>
                <Row style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '1rem'}}>
                    <Col>
                        <img
                            src={LOGO_URL}
                            width={'25%'}
                            height={'auto'}
                            alt={'hsh-logo'}
                            style={{
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                width: '50%'
                            }}
                        />
                    </Col>
                    <Col>
                        <h1>Check your inbox</h1>
                        <h3>{`We sent a verification link to ${this.state.submittedEmail}. Click the link to activate your account.`}</h3>
                        <p>Didn't receive it? <Link to="/register">Try again</Link></p>
                    </Col>
                </Row>
            </Container>
        }

        return <Container style={{color: 'white'}}>
            <Row style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '1rem'}}>
                <Col>
                    <img
                        src={LOGO_URL}
                        width={'25%'}
                        height={'auto'}
                        alt={'hsh-logo'}
                        style={{
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            width: '50%'
                        }}
                    />
                </Col>
                <Col>
                    <h1>Haunted Space Hotel Registration</h1>
                </Col>
            </Row>
            <Row style={{textAlign: 'center'}}>
                <p>HSH is an Online Game - Internet Connectivity is Required to Play.</p>
                <p>HSH Multiplayer - Basic is Free!</p>
                <p>Upgrade your account to get the 3D version and access to exclusive content!</p>
                <p>STATUS: Pre-Release.</p>
            </Row>
            <Form onSubmit={this.onSubmit}
                  validated={!this.state.isSaved}>
                {this.state.errors && this.state.errors.detail &&
                <Alert variant={'danger'}>{this.state.errors.detail}</Alert>}
                {this.state.errors && this.state.errors.non_field_errors &&
                <Alert
                    variant={'danger'}>{this.state.errors.non_field_errors}</Alert>}
                <FormGroup>
                    <Form.Label column={'username'}>
                        Account Username (you will need this to login, no spaces)
                    </Form.Label>
                    <Form.Control type="text"
                                  id={'username'}
                                  name={'username'}
                                  autoComplete="username"
                                  onChange={this.onFieldChange}
                                  value={this.state.username}
                                  isInvalid={!!this.state.errors.username}
                                  required
                    />
                    <Form.Control.Feedback type="invalid">
                        {this.state.errors.username}
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {this.state.usernameValidationmessage}
                    </Form.Control.Feedback>
                    <Form.Label column={'apassword'}>
                        Password
                    </Form.Label>
                    <Form.Control type="password"
                                  id={'apassword'}
                                  name={'apassword'}
                                  autoComplete="off"
                                  onChange={this.onFieldChange}
                                  value={this.state.apassword}
                                  isInvalid={this.state.errors && !!this.state.errors.password}
                                  placeholder={'Input New Password'}
                                  minLength={9}
                    />
                    <Form.Control.Feedback type="invalid">
                        {this.state.errors && this.state.errors.password}
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {this.state.apasswordValidationmessage}
                    </Form.Control.Feedback>
                    <Form.Label column={'apassword2'}>
                        Confirm Password
                    </Form.Label>
                    <Form.Control type="password"
                                  id={'apassword2'}
                                  name={'apassword2'}
                                  autoComplete="new-password"
                                  onChange={this.onFieldChange}
                                  value={this.state.apassword2}
                                  isInvalid={this.state.errors && !!this.state.errors.password}
                                  minLength={9}
                    />
                    <Form.Control.Feedback type="invalid">
                        {this.state.errors && this.state.errors.password}
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {this.state.apassword2Validationmessage}
                    </Form.Control.Feedback>

                    <Form.Label column={'email'}>
                        Email (optional &mdash; enables password resets and friend finder; leave blank to stay anonymous)
                    </Form.Label>
                    <Form.Control type="email"
                                  id={'email'}
                                  name={'email'}
                                  onChange={this.onFieldChange}
                                  value={this.state.email}
                                  isInvalid={this.state.errors && !!this.state.errors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                        {this.state.errors && this.state.errors.email}
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {this.state.emailValidationmessage}
                    </Form.Control.Feedback>

                    <Form.Label column={'timezone'}>
                        Default Timezone
                    </Form.Label>
                    <Form.Control as="select"
                                  id={'timezone'}
                                  name={'timezone'}
                                  value={this.state.timezone || ''}
                                  onChange={this.onFieldChange}
                                  isInvalid={!!this.state.errors.timezone}
                                  required={true}
                    >
                        {this.timezoneOptionList()}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                        {this.state.errors.timezone}
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {this.state.timezoneValidationmessage}
                    </Form.Control.Feedback>

                </FormGroup>
                <Button type={'submit'} variant={'stem'}
                        style={{ width: '100%' }}
                        disabled={this.state.isSaved}>Submit</Button>
            </Form>
            <Link to="/"><Button variant={'seed'}>Return to Login</Button></Link>

            <a href="https://hauntedspacehotel.com/">
                <Button variant={'dread'}>Home</Button>
            </a>
        </Container>
    }
}
